/**
 * 二手车新市场代办业务汇总
 */
import React from 'react';

import { Input, Row, Col, DatePicker, Statistic } from 'antd';

import PageLayout from '../../ui/PageLayout';

//加载中遮罩
import Loading from '../../ui/Loading';

import { fixedNumber } from '../../../util/util';
import http from '../../../axios/http';

class TradeAgentStatisticsIndex extends React.Component {

    columns = [{
        title: '商户',
        dataIndex: 'memberName',
        width: '20%',
    }, {
        title: '接单人',
        dataIndex: 'grabUser',
        width: '10%',
    }, {
        title: '评价人',
        dataIndex: 'evaluator',
        width: '10%',
    }, {
        title: '车型',
        dataIndex: 'brandModel',
        width: '20%',
    }, {
        title: '车架号',
        dataIndex: 'vin',
        width: '20%',
    }, {
        title: '服务态度',
        dataIndex: 'attitude',
        width: '10%',
    }, {
        title: '办事效率',
        dataIndex: 'efficiency',
        width: '10%',
    }, {
        title: '提交时间',
        dataIndex: 'insertTime',
        width: '15%',
    }];

    state = {
        queryData: {}, //查询数据
        loadingVisible: false,

        statisticsData: {}, //汇总统计数据
    };

    componentDidMount() {
        this.reloadPageData({});
    }


    inputSearch = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value
        this.reloadPageData(queryData);
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.reloadPageData(queryData);
    }

    selectChange = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.reloadPageData(queryData);
    }

    /**
     * 重新触发查询页面数据
     */
    reloadPageData = (queryData) => {
        this.setState({ queryData: queryData });
        this.loadData(queryData);
        this.loadStatistics(queryData);
    }

    // 加载统计数据
    loadStatistics = (queryData) => {
        http.post({
            url: '/tradeAgentSum/findTradeStatistics',
            data: queryData,
            success: (res) => {
                let data = {};
                data["countNum"] = res["countNum"];
                data["attitudeAvg"] = fixedNumber(res["attitudeAvg"] == null ? 0 : res["attitudeAvg"], 2);
                data["efficiencyAvg"] = fixedNumber(res["efficiencyAvg"] == null ? 0 : res["efficiencyAvg"], 2);
                this.setState({ statisticsData: data });
            },
        });
    }

    //导出数据
    // download = () => {
    //     let queryData = this.state.queryData;
    //     if (queryData.startDate == null || queryData.startDate === "") {
    //         messager.notify("请选择时间段进行导出！");
    //         return;
    //     }
    //     this.setState({ loadingVisible: true });
    //     queryData.pageNo = 1;
    //     queryData.pageSize = 5000;
    //     http.download({
    //         url: '/tradeAgentSum/downloadAgentSum',
    //         data: queryData,
    //         fileName: "代办业务明细.xlsx",
    //         success: (res) => {
    //             this.setState({ loadingVisible: false });
    //         },
    //         error: (res) => {
    //             this.setState({ loadingVisible: false });
    //         }
    //     });
    // }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <Input.Search
                                    placeholder="接单员"
                                    onSearch={this.inputSearch.bind(this, "grabUser")}
                                    enterButton
                                    style={{ width: '150px', marginLeft: '10px' }}
                                />
                                <Input.Search
                                    placeholder="商户"
                                    onSearch={this.inputSearch.bind(this, "memberName")}
                                    enterButton
                                    style={{ width: '150px', marginLeft: '10px' }}
                                />
                                <Input.Search
                                    placeholder="评价人"
                                    onSearch={this.inputSearch.bind(this, "evaluator")}
                                    enterButton
                                    style={{ width: '150px', marginLeft: '10px' }}
                                />
                                <DatePicker.RangePicker onChange={this.rangePickerChange} style={{ margin: '0 10px' }} />
                                {/* <Select onChange={this.selectChange.bind(this, "customerSource")} allowClear={true} style={{ width: 180, margin: '0 10px' }}>
                                    {this.customerSourceArray.map(d => <Select.Option key={d["code"]}>{d["text"]}</Select.Option>)}
                                </Select> */}
                                {/* <Button type="primary" onClick={this.download} style={{ "float": "right" }}>导出</Button> */}
                            </Col>
                            <Col span={24}>
                                <Row style={{ marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #e8e8e8' }}>
                                    <Col span={8} style={{ textAlign: 'center' }}>
                                        <Statistic title="总数" value={this.state.statisticsData["countNum"]} />
                                    </Col>
                                    <Col span={8} style={{ textAlign: 'center' }}>
                                        <Statistic title="态度平均分" value={this.state.statisticsData["attitudeAvg"]} />
                                    </Col>
                                    <Col span={8} style={{ textAlign: 'center' }}>
                                        <Statistic title="效率平均分" value={this.state.statisticsData["efficiencyAvg"]} />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    )}
                    rowKey="applicationId"
                    url="/tradeAgentSum/pageTradeStatistics"
                    columns={this.columns}
                    loadData={(func) => { this.loadData = func }}
                />
                <Loading
                    visible={this.state.loadingVisible}
                    message="数据加载中"
                />
            </div>
        )
    }

}

export default TradeAgentStatisticsIndex;